import { commonFilter } from './filter';

/**
 * Creative Trends 列表页埋点
 */
export const CreativeTrendsPoint = {
  pageName: 'Creative Trends',
  pageId: '25111',
  pagePath: '/marketing/CreativeTrends',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    // Status Tab 切换
    status_tab_change: {
      buttonId: '2511101',
    },
    // Card/List 视图切换
    view_switch: {
      buttonId: '2511102',
    },
    // 搜索
    search: {
      buttonId: '2511103',
    },
    // 排序变更
    sort_change: {
      buttonId: '2511104',
    },
    // 卡片点击（打开 Drawer）
    card_click: {
      buttonId: '2511105',
    },
    // 表格行点击（打开 Drawer）
    row_click: {
      buttonId: '2511106',
    },
    // Drawer View All（跳转详情）
    drawer_view_all: {
      buttonId: '2511107',
    },
    // Drawer 标题点击（跳转详情）
    drawer_title_click: {
      buttonId: '2511108',
    },
    ...commonFilter,
  },
  card: {},
  table: {},
};

/**
 * Creative Trends 详情页埋点
 */
export const CreativeTrendsDetailsPoint = {
  pageName: 'Creative Trends Details',
  pageId: '25112',
  pagePath: '/marketing/CreativeTrends/Details',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    // Card/Table 视图切换
    view_switch: {
      buttonId: '2511201',
    },
    // 搜索
    search: {
      buttonId: '2511202',
    },
    // 排序变更
    sort_change: {
      buttonId: '2511203',
    },
    ...commonFilter,
  },
  card: {},
  table: {},
};
